import { BoardType, ParamsPanelProps } from 'Types';

import ZigZagParamsPanel from 'boardClasses/zigZag/ZigZagParamsPanel';

function PinwheelParamsPanel(props: ParamsPanelProps<BoardType.Pinwheel>) {
  return <ZigZagParamsPanel {...props} />;
}

export default PinwheelParamsPanel;
